import {
  PhoneValidationRule,
  PhoneValidationRules,
} from "./phoneValidation.types";

// 手机号校验规则配置
export const phoneValidationRules: PhoneValidationRules = [
  {
    id: "74AF0EC6C229466AB31B8D87B40DFB2A",
    countryId: "BR",
    regularExpression: "^(\\+?55|0)\\d{11}$",
    enabled: true,
  },
  {
    id: "9724900636D544C2AD7E84363FF46E6A",
    countryId: "IN",
    regularExpression: "^(\\+?91|0)\\d{10}$",
    enabled: true,
  },
  {
    id: "932F6D8FCCC94BBF8F26FAAFDE5C462F",
    countryId: "PH",
    regularExpression: "^(\\+?63|0)?(09\\d{9}|9\\d{9})$",
    enabled: true,
  },
  {
    id: "5673896832934C45999CCD0AB52085C3",
    countryId: "SG",
    regularExpression: "^(\\+?65|0)[13689]\\d{6,7}$",

    enabled: false,
  },
  {
    id: "BF5BAD420D974005B90AFE303D0AD7DC",
    countryId: "JP",
    regularExpression: "^(\\+?81|0)[789]\\d{8}$",

    enabled: false,
  },
  {
    id: "EBAC53D6D3884579855CC3816E207ACE",
    countryId: "ID",
    regularExpression: "^(\\+?62|0)[78]\\d{9}$",

    enabled: false,
  },
  {
    id: "AE928F996EC94BF8A1007001DAEB98D8",
    countryId: "US",
    regularExpression: "^(\\+?1|0)[2-9]\\d{9}$",

    enabled: true,
  },
  {
    id: "C4859AFAB3A6482B8862090E41506FD6",
    countryId: "MX",
    regularExpression: "^(?:\\+?52)?\\d{10}$",

    enabled: true,
  },
  {
    id: "F074E54B8FE44D4EA72883D72272906A",
    countryId: "PK",
    regularExpression: "^(\\+?92|0)[1-9]\\d{9}$",

    enabled: false,
  },
  {
    id: "0FFE4C39930F4B4B923144205A75DA1F",
    countryId: "CO",
    regularExpression: "^(\\+?57|0)[1-9]\\d{9}$",

    enabled: true,
  },
  {
    id: "2695D3493EDA455CBC62C2482EEF6B1F",
    countryId: "VN",
    regularExpression: "^(\\+?84|0)[1-9]\\d{8,9}$",

    enabled: false,
  },
  {
    id: "2AF823CAFC974FEE9CB00B624ABF91A4",
    countryId: "TH",
    regularExpression: "^(\\+?66|0)[689]\\d{8}$",

    enabled: false,
  },
  {
    id: "64E82A60CB034FECA6280CB13188591F",
    countryId: "AR",
    regularExpression: "^(?:\\+54|54)?\\d{8,20}$",
    enabled: true,
  },
  {
    id: "3225C61437574C60B9107FC57AE1CFBA",
    countryId: "RU",
    regularExpression: "^(\\+?7|0)[9]\\d{9}$",

    enabled: false,
  },
  {
    id: "79219BF2DA684AAAA8853626D202FBD4",
    countryId: "EG",
    regularExpression: "^(\\+?20|0)[1-9]\\d{8}$",

    enabled: false,
  },
  {
    id: "CC983C42741548BF99AC4CA4BB3C2A0B",
    countryId: "TR",
    regularExpression: "^(\\+?90|0)[5]\\d{9}$",

    enabled: false,
  },
  {
    id: "6C68C8D3327142A9BEF9B1825E5C95AC",
    countryId: "NG",
    // 支持 7034567890 或 07034567890（选 +234 时用户常带前导 0）
    regularExpression: "^(\\+?234|0)0?[7-9]\\d{9}$",
    enabled: true,
  },
  {
    id: "37580C19ED73475CA77D545EEBE18A7B",
    countryId: "MY",
    regularExpression: "^(\\+?60|0)[1-9]\\d{8,9}$",

    enabled: false,
  },
  {
    id: "12AE61A6167B433EADBF30CE215BCCBE",
    countryId: "AU",
    regularExpression: "^(\\+?61|0)[4]\\d{8}$",

    enabled: false,
  },
  {
    id: "F6A341384A464904B2A2B340328A8CAC",
    countryId: "CL",
    regularExpression: "^(\\+?56|0)?[9]\\d{8}$",

    enabled: true,
  },

  {
    id: "F6A341384A464904B2A2B340328A8CAD",
    countryId: "PE",
    regularExpression: "^(\\+?51)?(09\\d{8}|9\\d{8})$",
    enabled: true,
  },
];

/**
 * 根据国家ID获取手机号校验规则
 * @param countryId 国家ID
 * @returns 手机号校验规则，如果未找到或未启用则返回null
 */
export const getPhoneValidationRule = (
  countryId: string
): PhoneValidationRule | null => {
  const rule = phoneValidationRules.find(
    r => r.countryId === countryId && r.enabled
  );
  return rule || null;
};

/**
 * 获取所有启用的手机号校验规则
 * @returns 启用的手机号校验规则列表
 */
export const getEnabledPhoneValidationRules = (): PhoneValidationRules => {
  return phoneValidationRules.filter(r => r.enabled);
};

/**
 * 获取所有支持手机号注册的国家ID列表
 * @returns 国家ID列表
 */
export const getSupportedCountryIds = (): string[] => {
  return phoneValidationRules.filter(r => r.enabled).map(r => r.countryId);
};
